import Lottie from 'lottie-react';
import Loading from './loading.json';

export const withLoading =
  (Component: React.FC<any>) => (props: ILoadingProps) => {
    const isLoading = props.loading ?? false;

    return (
      <>
        {isLoading && (
          <div
            className="flex justify-center items-center absolute top-0 left-0 w-full h-full bg-white/50 z-9"
            data-testid={`${props?.id}-loading`}
          >
            <Lottie
              animationData={Loading}
              style={{ width: '62px', height: '62px' }}
            />
          </div>
        )}

        <Component {...props} />
      </>
    );
  };

export interface ILoadingProps {
  loading?: boolean;
  id?: string;
}
